import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#b8c1d0] text-white">
      {/* Scrolling Services Section */}
      <div className="w-full overflow-hidden mb-4 bg-blue-900 py-4 px-2 text-white text-lg">
        <div className="whitespace-nowrap flex gap-4 animate-scroll-left">
          <span>✦</span>
          <span>Web Development</span>
          <span>✦</span>
          <span>Software Development</span>
          <span>✦</span>
          <span>Cloud Solutions</span>
          <span>✦</span>
          <span>Mobile App Development</span>
          <span>✦</span>
          <span>Data Analytics</span>
          <span>✦</span>
          <span>SEO Optimization</span>
          <span>✦</span>
          <span>Social Media Marketing</span>
          <span>✦</span>
          <span>Product Photography</span>
          <span>✦</span>
          <span>Website Maintenance</span>
          <span>✦</span>
          <span>Website UI/UX Design</span>
          <span>✦</span>
          <span>Wireframing & Prototyping</span>
          <span>✦</span>
          <span>E-commerce UI/UX</span>
          <span>✦</span>
          <span>Accessibility Design</span>
        </div>
      </div>
      
      <div className="container mx-auto px-8 pb-2">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-3xl font-bold text-blue-700 mb-4">
              Let’s <span className="text-black">Connect there</span>
            </h3>
            <p className="text-black font-bold mb-6">
              Subscribe for Expert IT Tips & Special Offers
            </p>
            <div className="text-white flex space-x-4">
              <a
                href="https://www.instagram.com/techecosolution?igsh=anIwM3pqcmx0cXRu"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-400 hover:text-black text-3xl"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://wa.me/919483085077?text=Hello%20TES%20👋,%20I’d%20like%20to%20know%20more%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-700 hover:text-black text-3xl"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xl text-black font-bold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="text-black">+91 9483085077</li>
              <li className="text-black">contact@techecosolution.in</li>
              <li className="text-black">techecosolution@gmail.com</li>
              {/* <li className="text-white-400">2464 Royal Ln. Mesa, New Jersey 45463</li> */}
            </ul>
            {/* <div className="mt-6">
              <button className="bg-black hover:bg-black-100 text-white py-2 px-6 rounded">Contact Us</button>
            </div> */}
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-xl text-black font-bold mb-4">
              Get the latest information
            </h4>
            <div className="mt-6">
              <button
                className="bg-black hover:bg-blue-700 text-white py-2 px-6 rounded relative z-10"
                onClick={() => navigate('/contact-tes')}
              >
                Contact Us
              </button>
            </div>
            {/* Project By */}
            <div className="mt-6">
              <a
                href="https://navelio.in"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3"
              >
                <div className="rounded-full bg-white p-2 shadow-md ring-1 ring-gray-200 group-hover:ring-blue-500 transition">
                  <img
                    src="/navelio_logo.png"
                    alt="Navelio"
                    className="h-12 w-12 object-contain"
                  />
                </div>

                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-gray-500">
                    POWERED BY
                  </p>
                  <h5 className="text-xl font-bold text-black group-hover:text-blue-600 transition">
                    Navelio<span className="text-blue-600">.in</span>
                  </h5>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-blue-700 mt-8 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-black">
            <p className="md:mb-0">
              Copyright © 2025 Techecosolution. All Rights Reserved.
            </p>
            <div className="flex space-x-2 text-sm my-2 md:my-0">
              <button
                onClick={() => navigate('/privacy-policy')}
                className="text-black hover:text-blue-700 cursor-pointer bg-transparent border-none p-0 font-inherit underline"
              >
                Privacy Policy
              </button>
              <span>|</span>
              <button
                onClick={() => navigate('/terms-and-conditions')}
                className="text-black hover:text-blue-700 cursor-pointer bg-transparent border-none p-0 font-inherit underline"
              >
                Terms & Conditions
              </button>
            </div>
            <div className="flex space-x-4 text-sm">
              <span>Made with ❤️ in India</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
